module.exports = __webpack_public_path__ + "img/img_thumbnail_uasa.242414be.png";